import React, { useEffect, useState } from "react";
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import bg1 from "./Images/bg_1.jpg";
import "./CSS/ContactPage.css";
import firebase from 'firebase/compat/app';
import 'firebase/compat/database';
import 'firebase/compat/storage';
import Loader from "./Components/Loader";

const Contactpage=()=>{
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [latestId, setLatestId] = useState(0);
  const [feedbackMessage, setFeedbackMessage] = useState(""); 

  useEffect(() => {
    const fetchLatestId = async () => {
      try {
        const snapshot = await firebase.database()
          .ref("Contact Form")
          .orderByChild("Contact_id")
          .limitToLast(1)
          .once("value");
        if (snapshot.exists()) {
          const latestEntry = snapshot.val();
          const latestIdValue = Object.values(latestEntry)[0].Contact_id;
          setLatestId(latestIdValue);
        } else {
          setLatestId(0);
        }
      } catch (error) {
        console.error("Error fetching latest ID:", error);
      }
    };

    fetchLatestId();
  }, []);


  const handleSubmit = async (event) => {
    event.preventDefault();

    const db = firebase.database();

    try {
      console.log("Latest ID:", latestId);
      const newId = latestId + 1;
      console.log("New ID:", newId);
      // Push form data to the database
      await db.ref("Contact Form").push({
        Contact_id: newId,
        Contact_name: name,
        Contact_email: email,
        Contact_subject: subject,
        Contact_message: message,
      });

      // Clear form fields and set success message
      setName("");
      setEmail("");
      setSubject("");
      setMessage("");
    //   toast.success(`Message sent successfully`);
      setFeedbackMessage("Message sent successfully!"); 
    } catch (error) {
      console.error("Error storing form data:", error);
      setFeedbackMessage("Failed to send message. Please try again."); 
    //   toast.error(`Failed to send message. Please try again.`);
    }
  };

    return(
        <>
  <title>JanuShree - Free Bootstrap 4 Template by Colorlib</title>
  <meta charSet="utf-8" />
  <meta
    name="viewport"
    content="width=device-width, initial-scale=1, shrink-to-fit=no"
  />
  <link
    href="https://fonts.googleapis.com/css?family=Montserrat:300,400,600,700"
    rel="stylesheet"
  />
  <link rel="stylesheet" href="css/open-iconic-bootstrap.min.css" />
  <link rel="stylesheet" href="css/animate.css" />
  <link rel="stylesheet" href="css/owl.carousel.min.css" />
  <link rel="stylesheet" href="css/owl.theme.default.min.css" />
  <link rel="stylesheet" href="css/magnific-popup.css" />
  <link rel="stylesheet" href="css/aos.css" />
  <link rel="stylesheet" href="css/ionicons.min.css" />
  <link rel="stylesheet" href="css/bootstrap-datepicker.css" />
  <link rel="stylesheet" href="css/jquery.timepicker.css" />
  <link rel="stylesheet" href="css/flaticon.css" />
  <link rel="stylesheet" href="css/icomoon.css" />
  <link rel="stylesheet" href="css/style.css" />
 
  <Header/>
  {/* END nav */}
  <section className="ftco-section contact-section">
  <h2 className="text-center blackthemegradient">Contact Information</h2>
    <div className="container mt-5">
      <div className="row block-9">
        <div className="col-md-5 contact-info ftco-animate">
          <div className="row contactinfo">
            <div className="col-md-12">
              <p>
                <span className="blackthemegradient">Sholinganallur Branch:</span> Rajiv Gandhi Salai, Sholinganallur, Chennai, Tamil Nadu 600097
              </p>
            </div>
            <div className="col-md-12">
              <p>
                <span  className="blackthemegradient">Medavakkam Branch:</span> 200-A, Mambakkam - Medavakkam Main Rd, Medavakkam, Chennai, Tamil Nadu 600100
              </p>
            </div>
            <div className="col-md-12">
              <p>
                <span  className="blackthemegradient">Phone:</span>{" "}
                <a className="text-white" href="tel://+91 9841424435">+91 9841424435, +91 9962742919</a>
              </p>
            </div>
            <div className="col-md-12">
              <p>
                <span  className="blackthemegradient">Email:</span>{" "}
                <a className="text-white" href="mailto:janushree1515r@gmail.com">janushree1515r@gmail.com</a>
              </p>
            </div>
            <div className="col-md-12">
            <div className="row">
              {/* First iframe */}
              <div className="col-md-6 mb-4">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d59144.503921624215!2d80.1710122!3d12.9106985!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a525c1cf454af75%3A0xc176081c1277dede!2sJanushree%20Ladies%20Salon!5e1!3m2!1sen!2sin!4v1732867964689!5m2!1sen!2sin"
                  width="100%"
                  height="180"
                  style={{ borderRadius:"10px"}}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
              {/* Second iframe */}
              <div className="col-md-6 mb-4">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d59144.503921624215!2d80.1710122!3d12.9106985!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a525c1c199a2ae5%3A0x9d1e2123cd20b812!2sJanushree%20Beauty%20Saloon!5e1!3m2!1sen!2sin!4v1732867829337!5m2!1sen!2sin"
                  width="100%"
                  height="180"
                  style={{ borderRadius:"10px" }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
            </div>
          </div>

          </div>
        </div>
        <div className="col-md-1" />
        <div className="col-md-6 ftco-animate ftcocontact-form">
          <form  id="contact-form" onSubmit={handleSubmit} className="contact-form">
            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Your Name"
                    required
                    value={name}
                    onChange={(event) => setName(event.target.value)}
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Your Email"
                    pattern="[^ @]*@[^ @]*"
                    required
                    value={email}
                    onChange={(event) => setEmail(event.target.value)}
                  />
                </div>
              </div>
            </div>
            <div className="form-group">
              <input
                type="text"
                className="form-control"
                placeholder="Subject"
                required
                value={subject}
                onChange={(event) => setSubject(event.target.value)}
              />
            </div>
            <div className="form-group">
              <textarea
                name=""
                id=""
                cols={30}
                rows={7}
                className="form-control"
                placeholder="Message"
                defaultValue={""}
                required
                value={message}
                onChange={(event) => setMessage(event.target.value)}
              />
            </div>
            <div className="form-group" style={{marginLeft:"35%"}}>
              <input
                type="submit"
                defaultValue="Send Message"
                className="btn buttoncolor text-white py-3 px-5"
              />
            </div>
          </form>
        </div>
      </div>
    </div>
  </section>
  <Loader/>
 <Footer/>
 
</>

    );
}

export default Contactpage;